import { __read, __spread } from "tslib";
import { calculateTotalValue, formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { KEEN_TABLE_INTERVAL, KEEN_KEY } from '@keen.io/parser';
import { calculatePercent } from '../../utils';
import { VALUE, PERCENTAGE_VALUE } from '../../constants';
export var categoricalTransformation = function (data, keys, formatValue, columnName, includePercentageStack) {
    var columns = __spread([
        KEEN_TABLE_INTERVAL,
        columnName,
        VALUE
    ], (includePercentageStack ? [PERCENTAGE_VALUE] : []));
    var rows = [];
    data.forEach(function (item) {
        var dataSeriesTotal = calculateTotalValue([item], KEEN_KEY, keys);
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return __spread([
            item[KEEN_KEY],
            keyName,
            item[keyName] ? valueFormatter(item[keyName], formatValue) : 0
        ], (includePercentageStack
            ? [calculatePercent(item[keyName], dataSeriesTotal) + "%"]
            : [])); })));
    });
    return __spread([columns], rows);
};
